<!-- ══════════════════════════════════════════════════════════════
Encabezado
═══════════════════════════════════════════════════════════════ -->
<app-page-title [title]="title()"></app-page-title>
<app-page-loader [load]="pageLoad" [label]="title()" (retry)="init()"></app-page-loader>

<!-- ══════════════════════════════════════════════════════════════
Buscador + Tabla
═══════════════════════════════════════════════════════════════ -->
<div class="table-section">

  <div class="filter-bar filter-bar--flush">
    <div class="filter-card">
      <app-search-pill placeholder="Nombre o descripción…" (search)="onSearch($event)"></app-search-pill>
      <mat-button-toggle-group class="view-toggle" [value]="listView.mode" (change)="listView.set($event.value)" [hideSingleSelectionIndicator]="true" aria-label="Vista">
      <mat-button-toggle value="table" matTooltip="Vista de tabla"><mat-icon>table_rows</mat-icon></mat-button-toggle>
      <mat-button-toggle value="cards" matTooltip="Vista de tarjetas"><mat-icon>grid_view</mat-icon></mat-button-toggle>
    </mat-button-toggle-group>
    </div>
    <app-filter-chips [count]="dataSource.filteredData.length" [total]="dataSource.data.length" noun="roles"></app-filter-chips>
  </div>

  <div class="list-actions">
    <button mat-stroked-button (click)="pageLoad.refresh(loadAll())"><mat-icon>refresh</mat-icon> Actualizar</button>
    <button mat-stroked-button (click)="downloadExcel()" matTooltip="Descargar la tabla de roles como Excel">
        <mat-icon>download</mat-icon> Descargar (xlsx)
      </button>
      <button mat-flat-button color="primary" (click)="openCreate()">
        <mat-icon>add</mat-icon> Nuevo Rol
      </button>
  </div>

  <app-selection-bar [count]="sel.count" (export)="exportExcel(sel.selected)" (clear)="sel.clear()"></app-selection-bar>

  <mat-paginator [hidden]="listView.mode !== 'table'" [pageSize]="8" [pageSizeOptions]="[5, 8, 20]" showFirstLastButtons></mat-paginator>

  @if (loading()) {
    <div class="loading-row">
      <mat-spinner diameter="32"></mat-spinner>
      <span>Cargando roles...</span>
    </div>
  }


  @if (listView.mode === 'cards') {
    <div class="inv-cards cat-cards">
      @for (r of dataSource.filteredData; track $index) {
        <div class="cat-card" [class.cat-card--selected]="sel.isSelected(r)">
          <div class="cat-card__head">
            <mat-checkbox color="primary" [checked]="sel.isSelected(r)" (change)="sel.toggle(r)" matTooltip="Seleccionar"></mat-checkbox>
            <div class="role-avatar"><mat-icon>badge</mat-icon></div>
            <span class="cat-card__title">{{ r.name }}</span>
            @let count = getPermissionsCount(r);
            <span class="perm-total">{{ count }} {{ count === 1 ? 'permiso' : 'permisos' }}</span>
          </div>
          <div class="cat-card__body">
            <div class="cat-card__field"><span class="cat-card__label">Descripción:</span><span class="cat-card__value">{{ r.description || '—' }}</span></div>
            <div class="cat-card__field"><span class="cat-card__label">Módulos:</span></div>
            <div class="chips-cell">
              @for (label of getModuleLabels(r); track label) {
                <span class="chip chip-mod">{{ label }}</span>
              }
              @if (getModuleLabels(r).length === 0) {
                <span class="no-items">Sin módulos</span>
              }
            </div>
          </div>
          <div class="cat-card__actions">
            <button mat-icon-button color="primary" matTooltip="Editar" (click)="openEdit(r)"><mat-icon>edit</mat-icon></button>
            <button mat-icon-button color="warn" matTooltip="Eliminar" (click)="deleteRole(r)"><mat-icon>delete</mat-icon></button>
          </div>
        </div>
      }
      @if (dataSource.filteredData.length === 0) {
        <p class="inv-cards__empty">Sin resultados</p>
      }
    </div>
  }

  <div class="table-container mat-elevation-z2" [hidden]="listView.mode !== 'table'">
    <table mat-table [dataSource]="dataSource">

      <ng-container matColumnDef="select">
        <th mat-header-cell *matHeaderCellDef class="select-cell">
          <mat-checkbox color="primary" (change)="$event ? sel.toggleAll() : null" [checked]="sel.allSelected()" [indeterminate]="sel.someSelected()" matTooltip="Seleccionar todos los visibles"></mat-checkbox>
        </th>
        <td mat-cell *matCellDef="let row" class="select-cell">
          <mat-checkbox color="primary" (click)="$event.stopPropagation()" (change)="$event ? sel.toggle(row) : null" [checked]="sel.isSelected(row)"></mat-checkbox>
        </td>
      </ng-container>

      <ng-container matColumnDef="name">
        <th mat-header-cell *matHeaderCellDef>Rol</th>
        <td mat-cell *matCellDef="let r">
          <div class="name-cell">
            <div class="role-avatar">
              <mat-icon>badge</mat-icon>
            </div>
            <div>
              <span class="name">{{ r.name }}</span>
              <span class="desc">{{ r.description }}</span>
            </div>
          </div>
        </td>
      </ng-container>

      <ng-container matColumnDef="description">
        <th mat-header-cell *matHeaderCellDef>Descripción</th>
        <td mat-cell *matCellDef="let r">{{ r.description || '—' }}</td>
      </ng-container>

      <ng-container matColumnDef="modules">
        <th mat-header-cell *matHeaderCellDef>Módulos</th>
        <td mat-cell *matCellDef="let r">
          <div class="chips-cell">
            @for (label of getModuleLabels(r); track label) {
              <span class="chip chip-mod">{{ label }}</span>
            }
            @if (getModuleLabels(r).length === 0) {
              <span class="no-items">Sin módulos</span>
            }
          </div>
        </td>
      </ng-container>

      <ng-container matColumnDef="permissions">
        <th mat-header-cell *matHeaderCellDef>Permisos</th>
        <td mat-cell *matCellDef="let r">
          @let count = getPermissionsCount(r);
          @if (count > 0) {
            <span class="perm-total">{{ count }} {{ count === 1 ? 'permiso' : 'permisos' }}</span>
          } @else {
            <span class="no-items">Sin permisos</span>
          }
        </td>
      </ng-container>

      <ng-container matColumnDef="actions">
        <th mat-header-cell *matHeaderCellDef></th>
        <td mat-cell *matCellDef="let r">
          <button mat-icon-button color="primary" matTooltip="Editar"
            (click)="openEdit(r)">
            <mat-icon>edit</mat-icon>
          </button>
          <button mat-icon-button color="warn" matTooltip="Eliminar"
            (click)="deleteRole(r)">
            <mat-icon>delete</mat-icon>
          </button>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="columns; sticky: true"></tr>
      <tr mat-row *matRowDef="let row; columns: columns;" class="table-row"></tr>

      <tr class="no-data-row" *matNoDataRow>
        <td [attr.colspan]="columns.length">
          <div class="no-data">
            <mat-icon>search_off</mat-icon>
            <span>No se encontraron roles</span>
          </div>
        </td>
      </tr>
    </table>
  </div>


</div>